var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "save-box" }, [
    _c(
      "button",
      { staticClass: "save-btn", attrs: { disabled: _vm.is_disabled } },
      [_vm._v(_vm._s(_vm.title))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }